import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from '@/constants/routes';
import { useAuthStore } from '@/store/useAuthStore';

function isProfilePath(path: string) {
  return path.split(/[?#]/)[0].startsWith(ROUTES.profile);
}

export const AuthCheck = () => {
  const router = useRouter();
  const { asPath } = router;
  const { getBaseUser } = useAuth();

  useEffect(() => {
    getBaseUser();
  }, [asPath]);

  useEffect(() => {
    function handlePageShow(event: PageTransitionEvent) {
      if (!event.persisted) return;

      getBaseUser().then(() => {
        const { isAuthenticated } = useAuthStore.getState();

        if (isAuthenticated || !isProfilePath(router.asPath)) return;

        router.replace(ROUTES.home);
      });
    }

    window.addEventListener('pageshow', handlePageShow);

    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [getBaseUser, router]);

  return null;
};
